import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import Select from "react-select";

function AssignedToModal({ onClose, roleId, reference }) {
  const [eligibleUsers, setEligibleUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch eligible users
  useEffect(() => {
    if (!roleId) return;

    const fetchEligibleUsers = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.post(
          `${API_BASE_URL}/roles/assignedTo/add`,
          { role_id: roleId },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setEligibleUsers(res.data.eligibleUsers || []);
      } catch (err) {
        console.error("Error fetching eligible users:", err);
        setEligibleUsers([]);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchEligibleUsers();
  }, [roleId]);

  // Allocate user
  const handleAllocate = async () => {
    if (!selectedUser) {
      toastr.error("Please select a user");
      return;
    }

    try {
      setGlobalLoading(true);
      await axios.post(
        `${API_BASE_URL}/roles/assignedTo/add`,
        {
          role_id: roleId,
          user_id: selectedUser,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toastr.success("User assigned successfully");
      setSelectedUser("");
      onClose();
    } catch (err) {
      console.error("Allocation failed:", err);
      toastr.error(err.response?.data?.message || "Failed to allocate user");
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Assigned User (Reference: {reference})
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Select User</label>

              <Select
                options={eligibleUsers.map((user) => ({
                  value: user.id,
                  label: `${user.firstname} ${user.lastname} (${user.designation_name})`,
                }))}
                value={
                  eligibleUsers
                    .map((user) => ({
                      value: user.id,
                      label: `${user.firstname} ${user.lastname} (${user.designation_name})`,
                    }))
                    .find((option) => option.value === selectedUser) || null
                }
                onChange={(selectedOption) =>
                  setSelectedUser(selectedOption?.value || "")
                }
                isDisabled={eligibleUsers.length === 0}
                placeholder="-- Select User --"
                isSearchable
              />

              {eligibleUsers.length === 0 && (
                <p className="text-muted mt-2">No eligible users available.</p>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success ms-2"
              onClick={handleAllocate}
              disabled={!selectedUser}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssignedToModal;
